import React, { useState } from "react";
import logo from "./images/logo.png";
function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <header className="site-header">
        {/* Top announcement bar */}
        <div className="top-bar">
          Free shipping on orders over GHC5000 · Shop now
        </div>

        {/* Main row: logo | menu | search | login+cart */}
        <div className="main-row">
          <a href="/" className="logo">
            <img
              src={`${logo}`}
              alt="Prosep Services"
            />
          </a>

          <nav className={`nav-row ${menuOpen ? "open" : ""}`}>
            {/* HOME */}
            <div className="nav-item">
              <a href="/">HOME</a>
            </div>

            {/* PRODUCTS dropdown — matches footer categories */}
            <div className="nav-item">
              <a href="#">PRODUCTS ▾</a>
              <div className="dropdown">
                <a href="/product/category/cctv">CCTV</a>
                <a href="/product/category/chemicals">CHEMICALS</a>
                <a href="/product/category/door-security">DOOR SECURITY</a>
                <a href="/product/category/lab-equipment-consumables">
                  LAB EQUIPMENT &amp; CONSUMABLES
                </a>
                <a href="/product/category/loto-occupational-safety">
                  LOTO: OCCUPAIONAL SAFETY
                </a>
                <a href="/product/category/ppe">PPE</a>
                <a href="/product/category/padlock">PADLOCK</a>
                <a href="/product/category/pump-accessories-spare-parts">
                  PUMP ACCESSORIES - SPARE PARTS
                </a>
                <a href="/product/category/pumps">PUMPS</a>
                <a href="/product/category/torchlight">TORCHLIGHT</a>
              </div>
            </div>

            {/* SERVICES */}
            <div className="nav-item">
              <a href="/services/mining-mineral-processing">SERVICES</a>
            </div>

            {/* ABOUT US */}
            <div className="nav-item">
              <a href="/about">ABOUT US</a>
            </div>

            {/* CONTACT US */}
            <div className="nav-item">
              <a href="/contact">CONTACT US</a>
            </div>
          </nav>

          <div className="search-bar">
            <input type="text" placeholder="Search products..." />
            <button>🔍</button>
          </div>

          <div className="actions">
            <a href="/login" className="login-link">Login</a>
            <a href="/cart" className="cart-link">
              🛒
              <span className="cart-count">0</span>
            </a>
          </div>

          <button
            className="menu-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            ☰
          </button>
        </div>
      </header>

      <style>{`
        .site-header {
          background: #ffffff;
          border-bottom: 1px solid #e5e7eb;
          position: sticky;
          top: 0;
          z-index: 100;
          font-family: Arial, sans-serif;
        }

        .top-bar {
          background: #111;
          color: #fff;
          text-align: center;
          font-size: 13px;
          padding: 8px;
          letter-spacing: 0.5px;
        }

        .main-row {
          display: flex;
          align-items: center;
          gap: 24px;
          padding: 18px 40px;
          max-width: 1400px;
          margin: 0 auto;
        }

        /* Logo */
        .logo {
          display: flex;
          align-items: center;
          text-decoration: none;
          flex-shrink: 0;
        }
        .logo img {
          height: 54px;
          width: auto;
          display: block;
        }

        /* Menu */
        .nav-row {
          display: flex;
          align-items: center;
          gap: 24px;
          flex-shrink: 0;
        }

        .nav-item {
          position: relative;
        }

        .nav-item > a {
          text-decoration: none;
          color: #111;
          font-weight: 700;
          font-size: 14px;
          letter-spacing: 1px;
          padding: 10px 0;
          display: inline-block;
        }
        .nav-item > a:hover {
          color: #c8102e;
        }

        /* Dropdown panel */
        .dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          min-width: 280px;
          max-width: 340px;
          background: #ffffff;
          border: 1px solid #e5e7eb;
          border-radius: 6px;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
          padding: 8px 0;
          opacity: 0;
          visibility: hidden;
          transform: translateY(8px);
          transition: all 0.18s ease;
          z-index: 200;
        }

        .nav-item:hover .dropdown {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
        }

        .dropdown a {
          display: block;
          padding: 10px 20px;
          color: #111;
          text-decoration: none;
          font-size: 14px;
          font-weight: 500;
          white-space: normal;
          line-height: 1.4;
          letter-spacing: 0.3px;
        }
        .dropdown a:hover {
          background: #f3f4f6;
          color: #c8102e;
        }

        /* Search */
        .search-bar {
          flex: 1;
          display: flex;
          align-items: center;
          background: #f3f4f6;
          border-radius: 30px;
          overflow: hidden;
          max-width: 420px;
          margin-left: auto;
        }
        .search-bar input {
          flex: 1;
          border: none;
          background: transparent;
          padding: 10px 18px;
          font-size: 14px;
          outline: none;
        }
        .search-bar button {
          border: none;
          background: transparent;
          padding: 10px 18px;
          cursor: pointer;
          font-size: 16px;
        }
        .search-bar button:hover {
          color: #c8102e;
        }

        /* Login + Cart */
        .actions {
          display: flex;
          align-items: center;
          gap: 20px;
          flex-shrink: 0;
        }
        .login-link {
          text-decoration: none;
          color: #111;
          font-weight: 700;
          font-size: 14px;
          letter-spacing: 1px;
        }
        .login-link:hover {
          color: #c8102e;
        }
        .cart-link {
          position: relative;
          text-decoration: none;
          color: #111;
          font-size: 24px;
          display: flex;
          align-items: center;
        }
        .cart-link:hover {
          color: #c8102e;
        }
        .cart-count {
          position: absolute;
          top: -6px;
          right: -10px;
          background: #c8102e;
          color: #fff;
          font-size: 11px;
          font-weight: 700;
          border-radius: 50%;
          width: 18px;
          height: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        /* Hamburger */
        .menu-toggle {
          display: none;
          background: none;
          border: none;
          font-size: 26px;
          cursor: pointer;
          color: #111;
        }

        /* Mobile */
        @media (max-width: 900px) {
          .main-row {
            padding: 14px 20px;
            flex-wrap: wrap;
            gap: 16px;
          }

          .logo img {
            height: 38px;
          }

          .search-bar {
            order: 3;
            flex-basis: 100%;
            max-width: 100%;
            margin-left: 0;
          }

          .actions {
            margin-left: auto;
          }

          .menu-toggle {
            display: block;
          }

          .nav-row {
            display: none;
            order: 4;
            flex-direction: column;
            align-items: stretch;
            gap: 0;
            flex-basis: 100%;
            border-top: 1px solid #e5e7eb;
            margin-top: 8px;
          }
          .nav-row.open {
            display: flex;
          }

          .nav-item > a {
            padding: 14px 0;
            border-bottom: 1px solid #f3f4f6;
            display: block;
          }

          .dropdown {
            position: static;
            opacity: 1;
            visibility: visible;
            transform: none;
            box-shadow: none;
            border: none;
            padding: 0 0 8px 16px;
            max-width: 100%;
          }
          .dropdown a {
            padding: 8px 0;
            font-size: 13px;
          }
        }
      `}</style>
    </>
  );
}

export default Header;